import styled from 'styled-components';

export const Story = styled.div`
  padding: 16px 0;
`;

export const Wrapper = styled.div``;
